import { ref } from 'vue';
import { ElMessage } from 'element-plus';

export default ({ currentFavoriteId }) => {
    const show = ref(false);

    function open() {
        if (!currentFavoriteId.value) {
            ElMessage.error('请选择需要发送的收藏夹');
            return;
        }
        show.value = true;
    }

    function close() {
        show.value = false;
    }

    return { show, open, close }
}